<div class="flex h-full flex-col pt-3" [class.items-center]="!expanded$()">
  <div id="menu" class="flex flex-col gap-1 px-3 h-14 justify-center" [class.mb-3]="!expanded$()" [class.w-full]="expanded$()">
    <button mat-icon-button (click)="toggleSidebar()" type="button">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <div class="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto">
    <ul
      class="flex flex-col"
      [class.gap-0]="expanded$()"
      [class.gap-3]="!expanded$()"
      [class.px-3]="expanded$()"
      [class.px-0]="!expanded$()"
      data-cy="dtis-slim-navbar-baselinks"
    >
      <li class="list-none">
        <ng-content select="[custom]"></ng-content>
      </li>

      @for (item of routes().filter(r => !r.hidden); track item.name) {

      <li>
        <dtis-rail-btn
          [item$]="item"
          [icon$]="item.icon"
          [route$]="item.route"
          [onClick$]="item.onClick"
          [label$]="item.name"
          [expanded$]="expanded$()"
          [exactMatch$]="item.exactMatch ?? false"
        />
      </li>
      }
    </ul>
  </div>
  <ng-content select="[bottom]"></ng-content>
  @if (expanded$()) {
  <div class="flex w-full ml-4 ">
    <img src="/assets/DSS_rgb.svg" class="w-48 h-full object-contain" alt="DSS Logo">
  </div>
  } @else {
  <div class="flex w-full">
    <img src="/assets/DSS-Icon_only-rgb.svg" class="h-16 w-full object-contain" alt="DSS Logo">
  </div>
  }
</div>
